/**
 * Created by jacmai on 3/8/2017.
 */
define([
  "marionette",
  "jquery",
  "modules/actions/actionGroup/actionGroupItems/template/actionGroupItemsTemplate.html",
  "modules/actions/actionGroup/actionGroupItems/template/actionItemTemplate.html",
  "jquery-ui",
  "jquery-ui/ui/widgets/sortable",
], function (Marionette, $, ActionGroupItemsTemplate, ActionItemTemplate) {
  "use strict";

  var ActionGroupItemsView = {};

  ActionGroupItemsView.actionItemView = Marionette.ItemView.extend({
    template: ActionItemTemplate,
    tagName: "li",
    className: function () {
      //use the unique cid of the model as the class name so we can track it when it is moved by the user
      return this.model.cid;
    },
    initialize: function (options) {
      this.model.apis = options.apis;
      this.model.variables = options.variables;
    },
    modelEvents: {
      change: "render",
    },
    triggers: {
      "click #deleteActionItem": "delete:item",
      click: "edit:item",
    },
  });

  ActionGroupItemsView.actionGroupItemsView = Marionette.CompositeView.extend({
    template: ActionGroupItemsTemplate,
    itemView: ActionGroupItemsView.actionItemView,
    itemViewContainer: "#actionItemsList",
    collectionEvents: {
      sort: "render",
    },
    triggers: {
      "click #addAction": "add:item",
    },
    initialize: function (options) {
      this.apis = options.apis;
      this.variables = options.variables;
    },
    itemViewOptions: function () {
      return {
        apis: this.apis,
        variables: this.variables,
      };
    },
    onCompositeCollectionRendered: function () {
      var actionItemsList = this.$el.find("#actionItemsList");
      var collection = this.collection;
      //set up the sortable JQuery UI elements
      actionItemsList.sortable({
        placeholder: "action-item-placeholder",
        handle: ".icon-grip",
        update: function (event, ui) {
          //after moving the action item, get the new order and update the models
          actionItemsList.children().each(function (index) {
            var cid = $(this).attr("class");
            collection.get(cid).set("order", index);
          });
          //sort the collection to match the new order
          collection.sort();
        },
      });
    },
  });

  return ActionGroupItemsView;
});
